import * as React from "react";

;
export const ChevronLeftSmll = (props: React.SVGProps<SVGSVGElement>) => <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10.06 12l5.47 5.47-1.06 1.06L7.94 12l6.53-6.53 1.06 1.06L10.06 12z" fill="#100722" /></svg>;